/* eslint-disable */
// Auto-generated at build time by scripts/generate-config.js — DO NOT EDIT
const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://m5kmiloo3bbz5ptqykh2xnexkq.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-2:c850292a-0120-482a-b328-aaa7004437c1",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_B4YJ13Xur",
    "aws_user_pools_web_client_id": "i85c34k0r1um4javnk6ad772e",
    "oauth": {
        "domain": "taps-d24czhghzv95bs-main.auth.eu-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://taps.ons-iam-prod-c.census-aws.onsdigital.uk/",
        "redirectSignOut": "https://taps.ons-iam-prod-c.census-aws.onsdigital.uk/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_additionalAuthenticationTypes": "AWS_IAM"
};

export default awsmobile;
